import { Injectable } from '@angular/core';
import { Observable, Subject, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ColmecConfigurableHelperService {
  selectedRim: Subject<string> = new ReplaySubject<string>();

  constructor() {}

  public setSelectedRim(selectedRim: string) {
    this.selectedRim.next(selectedRim);
  }

  public getSelectedRim(): Observable<string> {
    return this.selectedRim.asObservable();
  }
}
